var instantiatedAudioCtx = null;
var hasTriedInstantiateCtx = false;

export var getAudioContext = function()
{

    var contextPrototype = window.AudioContext // Default
        || window.webkitAudioContext // Safari and old versions of Chrome
        || false; 
    

    // Do whatever you want using the Web Audio API
    if(contextPrototype)
    {
    	if(!hasTriedInstantiateCtx){
    		hasTriedInstantiateCtx = true;
    		console.log("Instantiating new AUdio Context");
        	instantiatedAudioCtx = new contextPrototype();
    	}

        return instantiatedAudioCtx;
    }
    else
        return null;

};	

export var loadAudioFile = function(url, audioCtx, successCallback, failCallback, object) {

	//console.log("Trying to load: " + url);
	var err = function(message, request) {
		console.log(message, request);
	};

	var decodeSuccess = function(buffer) {
		successCallback(buffer, object);
	};

	var decodeError = function(request) {
		return function(response) {
			try {
				throw 'Error decoding sound at `' + url + '`. This is as good as the error gets. Sorry.';
			} catch (message) {
				if (typeof err === 'function') {
					err(message, request);
				}
				if(typeof failCallback != 'undefined')
					failCallback(object);
			}
		};
	}

	var decodeAudioData = function(e) {
		var request = e.currentTarget;

		if(request.status != 200)
		{
			console.log("Error - status: " + request.statusText);
			console.log("Error requesting file: " + request.responseURL);
			
			if(typeof failCallback != 'undefined')
					failCallback(object);
		}
		else
			audioCtx.decodeAudioData(request.response, decodeSuccess, decodeError(request));
	}

	var request = new XMLHttpRequest();

	request.open('GET', url);
	request.responseType = 'arraybuffer';
	request.onload = decodeAudioData;
	request.send();
};

var AudioPlaybackData = function(buffer, offset, duration)
{
	this.buffer = buffer;
	this.offset = offset;
	this.duration = duration;
}

//refObjects must be a list of objects the same length as filenames. When filename at index X 
//is loaded, the object at index X in refObjects is send as an argument in the loadedFileCallback
var loadAudioFiles = function(fileNames, prefix, extension, refObjects, resultMap,
	loadedFileCallback, audioCtx)
{
	var loadedCallback = function(buffer, object)
	{
		resultMap.set(object, buffer);
		if(loadedFileCallback != null)
			loadedFileCallback(buffer, object);
	};

	var failedCallback = function(buffer, object)
	{

	};

	for(var i = 0; i < fileNames.length; i++)
	{
		loadAudioFile(prefix + fileNames[i] + extension, audioCtx, loadedCallback, failedCallback, refObjects[i]);
	}
}

//refObjects must be a list of objects the same length as filenames. When filename at index X 
//is loaded, the object at index X in refObjects is send as an argument in the loadedFileCallback
var loadAudioFilesInSteps = function(fileNames, prefix, extension, refObjects, resultMap,
	loadedFileCallback, audioCtx)
{
	var loadObject = new Object();


	var maxSimultaneousLoads = 8;

	var simultaneousLoads = Math.min(fileNames.length, maxSimultaneousLoads);

	loadObject.nextIndex = simultaneousLoads;

	var loadedCallback = function(buffer, object)
	{
		resultMap.set(object, buffer);
		if(loadedFileCallback != null)
			loadedFileCallback(buffer, object);

		var myLoadIndex = loadObject.nextIndex++;
		//console.log("loaded: " + object)
		if(fileNames.length > myLoadIndex)
		{
			//console.log("Loading new index: " + myLoadIndex);
			loadAFileFunc(myLoadIndex);
		}
	};

	var failedCallback = function(buffer, object)
	{
		console.log("Loading failed for: " + object)
	};

	var loadAFileFunc = function(index)
	{
		loadAudioFile(prefix + fileNames[index] + extension, audioCtx, loadedCallback, failedCallback, refObjects[index]);
	}
	for(var i = 0; i < simultaneousLoads; i++)
	{
		loadAFileFunc(i);
	}
}



// WEBPACK FOOTER //
// ./js/AudioTools.js